import { TextField } from "@mui/material";
import { GlobalTextFieldStyles } from "../../../theme/global-styles";
import { capitalize } from "../../../utils";
import { AtTextareaProps } from "./at-textarea.types";

export const AtTextarea = ({
  label,
  required,
  onChange,
  disabled,
  error,
  value,
  helpText,
  rows = 6,
  autoCapitalization,
  maxChars,
}: AtTextareaProps) => {
  const handleChange = (value: string) => {
    const formattedValue = autoCapitalization ? capitalize(value) : value;
    onChange?.(formattedValue);
  };

  return (
    <>
      <GlobalTextFieldStyles />
      <TextField
        label={label}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        disabled={disabled}
        required={required}
        error={error}
        helperText={
          <span className="w-full flex justify-between">
            <span>{helpText}</span>
            {maxChars && (
              <span>
                {value.length}/{maxChars}
              </span>
            )}
          </span>
        }
        multiline
        rows={rows}
        size="small"
        variant="outlined"
        fullWidth
      />
    </>
  );
};
